var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Name=Arrow-Left"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    opacity: 0.01,
    width: 24,
    height: 24,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7517 7.19614C11.5357 6.99183 11.2131 6.94506 10.9486 7.06559L10.8383 7.12886L10.7543 7.19646L6.20564 11.5189C5.98973 11.7236 5.93989 12.039 6.07489 12.3044L6.13422 12.4013L6.20499 12.4811L10.7539 16.8037C11.0299 17.0654 11.4754 17.0654 11.7516 16.8036C11.9695 16.5964 12.0197 16.2832 11.8828 16.018L11.8226 15.9211L11.7515 15.8416L7.70956 11.9991L11.7519 8.15817C11.9753 7.94634 12.02 7.62731 11.8858 7.37251L11.8271 7.28031L11.7517 7.19614ZM17.7904 7.19614C17.5744 6.99183 17.2518 6.94506 16.9873 7.06559L16.8912 7.11864L16.793 7.19646L12.2443 11.5189C12.0284 11.7236 11.9786 12.039 12.1136 12.3044L12.1729 12.4013L12.2437 12.4811L16.7926 16.8037C17.0686 17.0654 17.5141 17.0654 17.7903 16.8036C18.0082 16.5964 18.0584 16.2832 17.9215 16.018L17.8613 15.9211L17.7902 15.8416L13.7476 12L17.7906 8.15817C18.014 7.94634 18.0587 7.62731 17.9245 7.37251L17.8658 7.28031L17.7904 7.19614Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.c5a34403926691f40c9500d66cb7f69b.svg";
export { ForwardRef as ReactComponent };